import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { RideBookingsActions } from './ride-bookings.actions';
import { RideBookingsPartialStoreState } from './ride-bookings.reducer';
import * as RideBookingsSelectors from './ride-bookings.selectors';

@Injectable()
export class RideBookingsFacade {
    bookings$ = this.store.select(RideBookingsSelectors.getBookings);
    loading$: Observable<boolean> = this.store.select(RideBookingsSelectors.getLoading);

    constructor(
        private store: NgRedux<RideBookingsPartialStoreState>,
        private actions: RideBookingsActions
    ) {}

    fetchRideBookings() {
        return this.store.dispatch(this.actions.fetchRideBookings());
    }
}
